var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSharedDistributionGroup = function SvgSharedDistributionGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.55,
    fill: "#939393",
    r: 10,
    cy: 10,
    cx: 10
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5.10552,7.26811c0.8095,-0.20997 1.54505,-0.26609 2.13997,-0.23242l0.6233,0.03499l0,1.00164l2.03564,-2.0198l-2.03564,-2.03564l0,1.03466l-0.64641,0.01321c-2.04555,0.04424 -3.58862,1.16869 -4.11222,3.04191c0.63255,-0.38296 1.30273,-0.65896 1.99537,-0.83856zm-2.84911,2.3255c0,-3.30074 2.24891,-5.13037 4.9521,-5.18848l0,-1.98216l3.63154,3.63154l-3.63154,3.60315l0,-1.96301a5.36477,5.36477 0 0 0 -0.55397,0l-0.10631,0c-0.99042,0.07065 -2.74478,0.41334 -4.29182,1.89896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.16885,9.53419a2.47605,2.47605 0 1 1 2.9356,0a3.3014,3.3014 0 0 1 1.8336,2.95805l-0.82535,0a2.47605,2.47605 0 1 0 -4.9521,0c0,0.81809 -0.39617,1.54307 -1.00825,1.99404a3.3014,3.3014 0 0 1 1.8336,2.95805l-0.82535,0a2.47605,2.47605 0 1 0 -4.9521,0l-0.82535,0a3.3014,3.3014 0 0 1 1.8336,-2.95805a2.47605,2.47605 0 1 1 3.46185,-3.46185a3.31526,3.31526 0 0 1 1.49025,-1.49025zm-3.4843,4.60875a1.6507,1.6507 0 1 0 0,-3.3014a1.6507,1.6507 0 0 0 0,3.3014zm4.9521,-4.9521a1.6507,1.6507 0 1 0 0,-3.3014a1.6507,1.6507 0 0 0 0,3.3014z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })))));
};
export default SvgSharedDistributionGroup;